/* src/app/job-signoff-shredder/pages/job-signoff-shredder/job-signoff-shredder.component.scss */
/*# sourceMappingURL=job-signoff-shredder.component.css.map */
